import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'employee',
	state : {
		employees: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/employees') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				let query = {};

				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
					query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}

				const resp = yield call(all, 'Employee', {
					where: query,
					include: 'hotel,createdBy', 
					skip: 0, 
					limit: limit, 
					count: 1, 
					order: '-createdAt'
				})
				const employees = resp.results;

				yield put({ type: 'queryFirst', payload: {
					employees: employees, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel,createdBy'};

				const resp = yield call(all, 'Employee', data)
				const employees = resp.results;

				yield put({ type: 'querySuccess', payload: {
					employees: employees,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*filter({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Employee', {...payload, include: 'hotel,createdBy'})

				yield put({ type: 'filterSuccess', payload: {
					employees: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}

				payload.hotel ? data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: payload.hotel.key} : payload.hotel = null;

				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'Employee', payload.objectId, data);
				yield put({ type: 'updateSuccess', payload: {...data, hotel: payload.hotel, objectId: payload.objectId} })
				message.success('Se ha actualizado el empleado exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Employee', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				employees: state.employees.concat(action.payload.employees),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				employees: action.payload.employees,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.employees, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			employees: _.without(state.employees, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/employee.js